import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import cloneDeep from 'lodash/cloneDeep';
import Utils from '../../../../../utils';
import ACTIONS from '../actions';
var DATA_CACHING = {};

var decryptSignature =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(fieldId, signatureData) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (signatureData) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve({
              id: fieldId,
              value: signatureData
            }));

          case 2:
            if (!DATA_CACHING[signatureData]) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.resolve({
              id: fieldId,
              value: DATA_CACHING[signatureData]
            }));

          case 4:
            return _context.abrupt("return", new Promise(function (resolve) {
              Utils.request({
                method: 'POST',
                url: '/backend/cryptography?type=signature',
                contentType: 'json',
                data: JSON.stringify(signatureData)
              }).then(function (decrypted) {
                DATA_CACHING[signatureData] = decrypted;
                resolve({
                  id: fieldId,
                  value: decrypted
                });
              });
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function decryptSignature(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var formFieldsAction = function formFieldsAction(changes) {
  return {
    type: ACTIONS.ADD_FIELDS,
    payload: changes.fields
  };
};

var formFieldsPropertiesActions = function formFieldsPropertiesActions(changes) {
  return {
    type: ACTIONS.SET_FIELDS_PROPERTIES,
    payload: changes.props
  };
};

var formDataAction = function formDataAction(changes) {
  return {
    type: ACTIONS.SET_FIELDS_VALUES,
    payload: changes.data
  };
};

var dispatchAsync = function dispatchAsync(asyncData, dispatch) {
  if (!asyncData || !Object.keys(asyncData).length) return; // get all promises for signatures

  var promises = Object.keys(asyncData).map(function (key) {
    return asyncData[key];
  });
  return Promise.all(promises).then(function (values) {
    var fieldsValueReducer = function fieldsValueReducer(result, val) {
      result[val.id] = val.value;
      return result;
    };

    var fieldsValues = values.reduce(fieldsValueReducer, {});
    var action = {
      type: ACTIONS.SET_FIELDS_VALUES,
      payload: fieldsValues
    };
    dispatch(action);
  });
};
/**
 * @param {import('../types').EcrionFormState} state
 * @param {Document} document
 * @return {import('../types').EcrionFormState}
 */


var formDataLoader = function formDataLoader(state, document, dispatch) {
  // when no data, we consider that form data is loaded
  if (!document) return dispatch({
    type: 'FORM_DATA_LOADED'
  });
  var formId = state.formId;

  var fields = _objectSpread({}, state.fields);

  var changes = {
    data: {},
    fields: {},
    props: [],
    asyncData: {}
  };
  loadFormData(fields, fields[formId], document.documentElement, changes);
  dispatch(formFieldsAction(changes));
  dispatch(formFieldsPropertiesActions(changes));
  dispatch(formDataAction(changes));
  var promise = dispatchAsync(changes.asyncData, dispatch);

  if (promise && promise.then) {
    promise.then(function () {
      return dispatch({
        type: 'FORM_DATA_LOADED'
      });
    });
  } else {
    dispatch({
      type: 'FORM_DATA_LOADED'
    });
  }
};
/**
 * @param {import('../types').EcrionFormFields} fields
 * @param {import('../types').EcrionFormContainer} container
 * @param {Element} domElement
 */


var loadFormData = function loadFormData(fields, container, domElement, changes) {
  if (!container || !domElement) return;

  switch (container.type) {
    case 'repeating':
      return loadRepeatingFormData(fields, container, domElement, changes);

    case 'datagroup':
      return loadDatagroupFormData(fields, container, domElement, changes);

    case 'radiogroup':
      return loadRadioGroupData(fields, container, domElement, changes);

    case 'checkboxgroup':
      return loadCheckboxGroupData(fields, container, domElement, changes);

    case 'dropdown':
      return loadDropdownData(fields, container, domElement, changes);

    case 'form':
    case 'page':
    case 'subform':
      return loadFormDataRecursive(fields, container, domElement, changes);

    default:
      return loadFieldData(fields, container, domElement, changes);
  }
};
/**
 * @param {import('../types').EcrionFormFields} fields
 * @param {import('../types').EcrionFormField} repeating
 * @param {Element} domElement
 */


var loadRepeatingFormData = function loadRepeatingFormData(fields, repeating, domElement, changes) {
  if (!repeating || !domElement) return;
  if (!repeating.children) return;
  /** @type {Array<{ value: number; children: Array<string> }>} */

  var childrenMap = [];
  var idx = 0;
  var nodes = findNodesByName(domElement, 'item');
  var values = nodes.map(function () {
    return idx++;
  });
  var contextSuffix = findContextSuffix(fields, repeating.id);
  changes.data[repeating.id] = values; // set current values

  values.forEach(function (value) {
    var newFields = repeating.children.map(function (childId) {
      var newField = cloneDeep(fields[childId]);
      newField.id = newField.id + "".concat(contextSuffix, "_").concat(value);
      newField.parentId = repeating.id;
      newField.originalId = childId; // add to the fields (now it is a field with all rights)

      fields[newField.id] = newField;
      changes.fields[newField.id] = newField;
      return newField;
    });
    childrenMap.push({
      value: value,
      children: newFields.map(function (f) {
        return f.id;
      })
    });
    var container = {
      children: newFields.map(function (field) {
        return field.id;
      })
    };
    loadFormDataRecursive(fields, container, nodes[value], changes);
  });
  changes.props.push({
    id: repeating.id,
    updateProperties: {
      childrenMap: childrenMap
    }
  });
};
/**
 * @param {import('../types').EcrionFormFields} fields
 * @param {import('../types').EcrionFormField} field
 * @param {Element} domElement
 */


var loadDatagroupFormData = function loadDatagroupFormData(fields, field, domElement, changes) {
  if (!field || !domElement) return;
  var nodes = findNodesByName(domElement, 'item');
  loadFormDataRecursive(fields, field, nodes[0], changes);
};
/**
 * @param {import('../types').EcrionFormFields} fields
 * @param {import('../types').EcrionFormField} field
 * @param {Element} domElement
 */


var loadRadioGroupData = function loadRadioGroupData(fields, field, domElement, changes) {
  if (!field || !domElement) return;
  var nodes = findNodesByName(domElement, 'item');
  changes.data[field.id] = nodes.length && nodes[0].textContent;
};
/**
 * @param {import('../types').EcrionFormFields} fields
 * @param {import('../types').EcrionFormField} field
 * @param {Element} domElement
 */


var loadCheckboxGroupData = function loadCheckboxGroupData(fields, field, domElement, changes) {
  if (!field || !domElement) return;
  var nodes = findNodesByName(domElement, 'item');
  changes.data[field.id] = nodes.map(function (node) {
    return node.textContent;
  });
};
/**
 * @param {import('../types').EcrionFormFields} fields
 * @param {import('../types').EcrionFormField} field
 * @param {Element} domElement
 */


var loadDropdownData = function loadDropdownData(fields, field, domElement, changes) {
  if (!field || !domElement) return;
  var nodes = findNodesByName(domElement, 'item');
  var value = field.multiple ? nodes.map(function (node) {
    return node.textContent;
  }) : nodes.length && nodes[0].textContent;
  changes.data[field.id] = value;
};
/**
 * @param {import('../types').EcrionFormState} fields
 * @param {import('../types').EcrionFormField} field
 * @param {Element} domElement
 */


var loadFieldData = function loadFieldData(fields, field, domElement, changes) {
  if (!field || !domElement) return;

  switch (field.type) {
    case 'signature':
      changes.asyncData[field.id] = decryptSignature(field.id, domElement.textContent);
      break;

    case 'file':
      {
        var fileName = domElement.getAttribute('fileName');
        var value = fileName ? {
          fileName: fileName,
          value: domElement.textContent
        } : domElement.textContent;
        changes.data[field.id] = value;
        break;
      }

    case 'xmlfield':
    case 'richtext':
      changes.data[field.id] = domElement.innerHTML;
      break;

    default:
      changes.data[field.id] = domElement.textContent;
      break;
  }
};
/**
 * @param {import('../types').EcrionFormState} fields
 * @param {import('../types').EcrionFormContainer} container
 * @param {Element} domElement
 */


var loadFormDataRecursive = function loadFormDataRecursive(fields, container, domElement, changes) {
  if (!domElement.hasChildNodes) return;
  if (!container.children) return;
  var fieldsList = container.children.map(function (childId) {
    return fields[childId];
  });
  var childNodes = domElement.childNodes;
  fieldsList.forEach(function (field) {
    loadFormData(fields, field, findNode(field, childNodes), changes);
  });
};
/**
 * @param {EcrionFormFields} fields
 * @param {string} fieldId
 * @return {string}
 */


var findContextSuffix = function findContextSuffix(fields, fieldId) {
  var field = fields[fieldId];
  var parentField = fields[field.parentId];
  if (!parentField || !parentField.children) return '';
  var suffix = '';
  parentField.children.forEach(function (childId) {
    if (fieldId.startsWith(childId)) suffix = fieldId.substring(childId.length);
  });
  return suffix;
};

var findNode = function findNode(field, childNodes) {
  for (var idx = 0; idx < childNodes.length; idx++) {
    if (childNodes[idx].nodeName === field.name) return childNodes[idx];
  }
};

var findNodesByName = function findNodesByName(element, name) {
  var result = [];
  if (!element.hasChildNodes) return result;

  for (var idx = 0; idx < element.childNodes.length; idx++) {
    if (element.childNodes[idx].nodeName === name) result.push(element.childNodes[idx]);
  }

  return result;
};

export default formDataLoader;